import Lead1 from "../assets/TeamLead/lead1.webp";
import Lead2 from "../assets/TeamLead/lead2.webp";
import Lead3 from "../assets/TeamLead/lead3.webp";
import Lead4 from "../assets/TeamLead/lead4.webp";
import Lead5 from "../assets/TeamLead/lead5.webp";
import Lead6 from "../assets/TeamLead/lead6.webp";
import Lead7 from "../assets/TeamLead/lead7.webp";
import Lead8 from "../assets/TeamLead/lead8.webp";
import Lead9 from "../assets/TeamLead/lead9.webp";

const agentsData = [
  {
    id: 1,
    name: "Mosab Al Halaby",
    role: "Senior Property Consultant",
    image: Lead1,
    languages: ["Arabic", "English"],
    properties: 1065,
    verified: true,
  },
  {
    id: 2,
    name: "Zein Alabideen Hweijeh",
    role: "Property Consultant",
    image: Lead2,
    languages: ["Arabic", "English"],
    properties: 1173,
    verified: true,
  },
  {
    id: 3,
    name: "Omar Al Laham",
    role: "Property Consultant",
    image: Lead3,
    languages: ["Arabic", "English"],
    properties: 1169,
    verified: true,
  },
  {
    id: 4,
    name: "Anne Baloch",
    role: "Property Consultant",
    image: Lead4,
    languages: ["Urdu", "English"],
    properties: 1138,
    verified: true,
  },
  {
    id: 5,
    name: "Vidhya Vinod",
    role: "Property Consultant",
    image: Lead5,
    languages: ["Hindi", "English", "Malayalam"],
    properties: 1134,
    verified: true,
  },
  {
    id: 6,
    name: "Mahmoud Wehba",
    role: "Property Consultant",
    image: Lead6,
    languages: ["Arabic", "English"],
    properties: 729,
    verified: true,
  },
  {
    id: 7,
    name: "Dhvani Patel",
    role: "Property Consultant",
    image: Lead7, // add image import
    languages: ["Hindi", "Tamil", "English", "Marathi", "Kannada"],
    properties: 669,
    desc: "Multilingual property consultant assisting diverse clients with residential and investment solutions.",
    verified: true,
  },
  {
    id: 8,
    name: "Ayman Mohamed Abdulqadir",
    role: "Property Consultant",
    image: Lead8, // add image import
    languages: ["Arabic", "English"],
    properties: 659,
    desc: "Trusted advisor specializing in residential properties with a strong focus on client satisfaction.",
    verified: true,
  },
  {
    id: 9,
    name: "Vimarsha Kavinda",
    role: "Property Consultant",
    image: Lead9, // add image import
    languages: ["Hindi", "English", "Sinhalese"],
    properties: 295,
    desc: "Client-oriented consultant helping buyers and tenants find the right property with confidence.",
    verified: true,
  },
];

export default agentsData;
